/* VarSang: il questionario della vetrina Shopify. Stessa ragione del CSS. */
(function(){
  var rot = document.getElementById('vq');
  if (!rot) return;
  var API = rot.dataset.api, VARIANT = rot.dataset.variant, PRIS = rot.dataset.pris;
  var scene = document.getElementById('vq-scene');
  var errBox = document.getElementById('vq-err');
  var NOKKEL = 'vaarsang.quiz.v1';

  /* ---------- Le otto domande ---------- */
  var SPM = [
    { id:'navn', type:'text', q:'Hvem er sangen til?',
      hint:'Navnet, skrevet slik du sier det. For eksempel: Siobhan &rarr; «Sjov-ann»',
      ph:'Skriv navnet' },
    { id:'anledning', type:'kort', q:'Hva er anledningen?',
      hint:'Velg det som passer best. Du kan alltid endre det etterpå.',
      valg:[['Bursdag','Ett år til å feire'],['Bryllup','Til de nygifte'],
            ['Jubileum','Feire kjærligheten'],['Eksamen','Endelig i mål'],
            ['Takk','Si det ordentlig'],['Bare fordi','Trenger ingen grunn'],
            ['Til minne','Hedre noen som er borte'],['Høytid','Jul, påske, 17. mai']] },
    { id:'stil', type:'kort', q:'Hvilken musikkstil?',
      hint:'Tenk på hva den du gir den til hører på selv.',
      valg:[['Pop','Lys og lett å like'],['Viser','Norsk, nær og enkel'],
            ['Country','Fortellende og varm'],['Rock','Med kraft i'],
            ['R&B','Mykt og sjelfullt'],['Folk','Akustisk og intim'],
            ['Jazz','Elegant og rolig'],['Hip hop','Rytmisk og direkte'],
            ['Klassisk','Tidløst og høytidelig']] },
    { id:'stemning', type:'kort', q:'Hvilken stemning?',
      hint:'Det er dette som avgjør om de smiler eller tørker en tåre.',
      valg:[['Glad og lett','God stemning hele veien'],['Romantisk','Full av kjærlighet'],
            ['Nostalgisk','Minner som varmer'],['Inspirerende','Gir noen mot'],
            ['Morsom','Med glimt i øyet'],['Følelsesladd','Rett i magen'],
            ['Energisk','Høyt tempo'],['Rolig','Stille og nær']] },
    { id:'stemme', type:'kort', q:'Hvem skal synge?',
      hint:'',
      valg:[['Kvinnestemme','Varm og bærende'],['Mannsstemme','Dyp og tydelig']] },
    { id:'historie', type:'area', q:'Fortell historien deres',
      hint:'Minner, private vitser, øyeblikk bare dere to vet om. Jo mer du skriver, jo mindre høres den ut som en mal.',
      ph:'For eksempel: Vi møttes på en fjelltur i 2015. Hun ler alltid av de dårlige vitsene mine. Vi har en hund som heter Balder...' },
    { id:'detaljer', type:'area', valgfri:true, q:'Noe som må være med?',
      hint:'Valgfritt. Et navn, en setning, et sted du vil høre i teksten.',
      ph:'For eksempel: kall henne «Bitte», nevn hytta på Geilo' },
    { id:'fra', type:'text', valgfri:true, q:'Hvem er den fra?',
      hint:'Valgfritt. Navnet ditt kan nevnes i sangen.',
      ph:'Ditt navn' }
  ];

  /* ---------- Stato ---------- */
  var S = { i:0, svar:{}, jobId:null, testo:null, epost:'' };
  try {
    var lagret = localStorage.getItem(NOKKEL);
    if (lagret) { var p = JSON.parse(lagret); if (p && p.svar) { S.svar = p.svar; S.i = p.i || 0; } }
  } catch(e){}
  function lagre(){ try{ localStorage.setItem(NOKKEL, JSON.stringify({svar:S.svar,i:S.i})); }catch(e){} }
  function tom(){ try{ localStorage.removeItem(NOKKEL); }catch(e){} }

  function feil(m){ errBox.textContent = m; errBox.hidden = !m; if(m) errBox.scrollIntoView({behavior:'smooth',block:'nearest'}); }

  function progresso(n, tot){
    var top = document.getElementById('vq-top');
    if (n === null) { top.style.visibility = 'hidden'; return; }
    top.style.visibility = 'visible';
    document.getElementById('vq-steg').textContent = 'Steg ' + n + ' av ' + tot;
    var pct = Math.round(n / tot * 100);
    document.getElementById('vq-pct').textContent = pct + ' %';
    document.getElementById('vq-fill').style.width = pct + '%';
  }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ---------- Le domande a schermo ---------- */
  function vis(){
    feil('');
    if (S.i >= SPM.length) return visOppsummering();
    var d = SPM[S.i];
    progresso(S.i + 1, SPM.length);

    var h = '<div class="vq-step"><h2>' + d.q + '</h2>';
    if (d.hint) h += '<p class="hint">' + d.hint + '</p>';
    h += '<div class="vq-field">';

    var v = S.svar[d.id] || '';
    if (d.type === 'text')
      h += '<input class="vq-input" id="vq-in" type="text" value="' + esc(v) + '" placeholder="' + esc(d.ph) + '">';
    else if (d.type === 'area')
      h += '<textarea class="vq-area" id="vq-in" placeholder="' + esc(d.ph) + '">' + esc(v) + '</textarea>';
    else {
      h += '<div class="vq-grid' + (d.valg.length === 2 ? ' one' : '') + '">';
      d.valg.forEach(function(o){
        h += '<button type="button" class="vq-card" data-v="' + esc(o[0]) + '" aria-pressed="' +
             (v === o[0]) + '"><b>' + esc(o[0]) + '</b>' + (o[1] ? '<span>' + esc(o[1]) + '</span>' : '') + '</button>';
      });
      h += '</div>';
    }
    h += '</div><div class="vq-nav">';
    h += S.i > 0 ? '<button class="vq-back" id="vq-b">&larr; Tilbake</button>' : '<span></span>';
    h += '<button class="vq-next" id="vq-n">' + (d.valgfri && !v ? 'Hopp over' : 'Videre') + ' &rarr;</button>';
    h += '</div></div>';
    scene.innerHTML = h;

    var inn = document.getElementById('vq-in');
    var neste = document.getElementById('vq-n');

    function sjekk(){
      var val = inn ? inn.value.trim() : (S.svar[d.id] || '');
      neste.disabled = !d.valgfri && !val;
      neste.innerHTML = (d.valgfri && !val ? 'Hopp over' : 'Videre') + ' &rarr;';
    }
    if (inn) {
      inn.addEventListener('input', function(){ S.svar[d.id] = inn.value; lagre(); sjekk(); });
      if (d.type === 'text') inn.addEventListener('keydown', function(e){
        if (e.key === 'Enter' && !neste.disabled) { e.preventDefault(); neste.click(); } });
      setTimeout(function(){ inn.focus(); }, 60);
    }
    scene.querySelectorAll('.vq-card').forEach(function(b){
      b.addEventListener('click', function(){
        S.svar[d.id] = b.dataset.v; lagre();
        scene.querySelectorAll('.vq-card').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        setTimeout(function(){ S.i++; lagre(); vis(); }, 190);
      });
    });
    sjekk();

    if (S.i > 0) document.getElementById('vq-b').addEventListener('click', function(){ S.i--; lagre(); vis(); });
    neste.addEventListener('click', function(){ S.i++; lagre(); vis(); });
  }

  /* ---------- Riepilogo ---------- */
  function visOppsummering(){
    progresso(null);
    var h = '<div class="vq-step"><h2>Ser bra ut!</h2>' +
            '<p class="hint">Dette er det vi bygger sangen på. Sjekk at alt stemmer.</p><div class="vq-sum">';
    SPM.forEach(function(d, idx){
      var v = (S.svar[d.id] || '').trim();
      if (!v) return;
      h += '<div class="item"><div><p>' + d.q.replace(/\?$/,'') + '</p><p class="val">' + esc(v) + '</p></div>' +
           '<button data-i="' + idx + '">Endre</button></div>';
    });
    h += '</div><div class="vq-nav" style="justify-content:center;">' +
         '<button class="vq-next" id="vq-lag">Skriv teksten min &#9997;&#65039;</button></div></div>';
    scene.innerHTML = h;
    scene.querySelectorAll('.vq-sum button').forEach(function(b){
      b.addEventListener('click', function(){ S.i = +b.dataset.i; vis(); });
    });
    document.getElementById('vq-lag').addEventListener('click', startTesto);
  }

  /* ---------- Scrittura del testo ---------- */
  function brief(){
    return {
      perChi:      S.svar.navn || '',
      occasione:   S.svar.anledning || '',
      stile:       S.svar.stil || '',
      qualita:     S.svar.stemning || '',
      voce:        S.svar.stemme || '',
      ricordo1:    S.svar.historie || '',
      dettagli:    S.svar.detaljer || '',
      daChi:       S.svar.fra || '',
      email:       S.epost || '',
      senereEpost: true
    };
  }

  function venter(tit, sub){
    progresso(null);
    scene.innerHTML = '<div class="vq-step"><h2>' + tit + '</h2>' +
      '<div class="vq-load"><div class="vq-spin">&#9834;</div>' +
      '<p class="hint" style="margin-top:20px;">' + sub + '</p></div></div>';
  }

  function startTesto(){
    feil('');
    venter('Skriver teksten&hellip;', 'Vi gjør minnene dine om til vers. Det tar under et minutt.');
    fetch(API + '/api/song', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify(brief())
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if (!res.ok || !res.j.id) throw new Error(res.j.error || 'Noe gikk galt.');
        S.jobId = res.j.id;
        ventTesto(0);
      }).catch(function(e){
        visOppsummering();
        feil(e.message || 'Vi fikk ikke kontakt. Prøv en gang til.');
      });
  }

  function ventTesto(n){
    if (n > 60) { visOppsummering(); return feil('Dette tok uvanlig lang tid. Prøv en gang til.'); }
    fetch(API + '/api/song/' + S.jobId, {cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (j.testo && j.testo.sezioni && j.testo.sezioni.length) { S.testo = j.testo; skrivUt(); return; }
        if (j.status === 'failed') { visOppsummering(); return feil('Vi klarte ikke å skrive teksten. Prøv en gang til.'); }
        setTimeout(function(){ ventTesto(n + 1); }, 2500);
      }).catch(function(){ setTimeout(function(){ ventTesto(n + 1); }, 3000); });
  }

  /* Effetto macchina da scrivere: e il momento in cui la persona capisce che
     la canzone parla davvero di lei. Vale i secondi che costa. */
  function skrivUt(){
    progresso(null);
    scene.innerHTML = '<div class="vq-step"><h2>Teksten din</h2>' +
      '<p class="hint">Skrevet nå, for ' + esc(S.svar.navn) + '. Ingen andre har den.</p>' +
      '<div class="vq-lyr" id="vq-lyr"></div>' +
      '<div class="vq-acts" id="vq-acts" style="display:none;"></div></div>';

    var boks = document.getElementById('vq-lyr');
    var sez = S.testo.sezioni, si = 0, vi = 0, ci = 0;
    var hopp = false;

    var hoppKnapp = document.createElement('button');
    hoppKnapp.className = 'vq-ghost';
    hoppKnapp.style.cssText = 'margin:18px auto 0;display:block;font-size:.85rem;padding:9px 20px;';
    hoppKnapp.textContent = 'Vis alt med en gang';
    hoppKnapp.addEventListener('click', function(){ hopp = true; });
    scene.querySelector('.vq-step').insertBefore(hoppKnapp, document.getElementById('vq-acts'));

    function ferdig(){
      hoppKnapp.remove();
      boks.innerHTML = sez.map(function(s){
        return '<div class="sez"><h3>' + esc(s.nome) + '</h3><div class="v">' +
               esc(s.versi.join('\n')) + '</div></div>';
      }).join('');
      visHandlinger();
    }

    function tikk(){
      if (hopp || si >= sez.length) return ferdig();
      var s = sez[si], v = s.versi[vi] || '';
      var el = document.getElementById('sez-' + si);
      if (!el) {
        boks.insertAdjacentHTML('beforeend',
          '<div class="sez" id="wrap-' + si + '"><h3>' + esc(s.nome) + '</h3><div class="v" id="sez-' + si + '"></div></div>');
        el = document.getElementById('sez-' + si);
      }
      ci += 2;
      var fatte = s.versi.slice(0, vi).join('\n');
      var ora = v.slice(0, ci);
      el.innerHTML = esc(fatte + (fatte ? '\n' : '') + ora) + '<span class="vq-cursor"></span>';
      boks.scrollIntoView({behavior:'smooth', block:'end'});
      if (ci >= v.length) {
        ci = 0; vi++;
        if (vi >= s.versi.length) {
          el.innerHTML = esc(s.versi.join('\n'));
          si++; vi = 0;
        }
      }
      setTimeout(tikk, 22);
    }
    tikk();
  }

  function visHandlinger(){
    var a = document.getElementById('vq-acts');
    a.style.display = 'flex';
    a.innerHTML = '<button class="vq-ghost" id="vq-endre">Endre teksten</button>' +
                  '<button class="vq-ghost" id="vq-om">Skriv en ny</button>' +
                  '<button class="vq-next" id="vq-syng">Lag sangen &#127925;</button>';
    document.getElementById('vq-endre').addEventListener('click', redigering);
    document.getElementById('vq-om').addEventListener('click', skrivOm);
    document.getElementById('vq-syng').addEventListener('click', apneEpost);
  }

  function redigering(){
    var boks = document.getElementById('vq-lyr');
    boks.innerHTML = S.testo.sezioni.map(function(s, i){
      return '<div class="sez"><h3>' + esc(s.nome) + '</h3>' +
             s.versi.map(function(v, j){
               return '<textarea data-s="' + i + '" data-v="' + j + '" rows="1">' + esc(v) + '</textarea>';
             }).join('') + '</div>';
    }).join('');
    boks.querySelectorAll('textarea').forEach(function(t){
      function vokse(){ t.style.height = 'auto'; t.style.height = t.scrollHeight + 'px'; }
      vokse();
      t.addEventListener('input', function(){
        vokse();
        S.testo.sezioni[+t.dataset.s].versi[+t.dataset.v] = t.value;
      });
    });
    var a = document.getElementById('vq-acts');
    a.innerHTML = '<button class="vq-next" id="vq-ferdig">Ferdig, lag sangen &#127925;</button>';
    document.getElementById('vq-ferdig').addEventListener('click', apneEpost);
  }

  function skrivOm(){
    venter('Skriver en ny&hellip;', 'Samme historie, andre ord.');
    fetch(API + '/api/song/' + S.jobId + '/rewrite', {
      method:'POST', headers:{'Content-Type':'application/json'}, body:'{}'
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if (!res.ok) throw new Error(res.j.error || 'Vi klarte ikke å skrive en ny.');
        if (res.j.testo) { S.testo = res.j.testo; skrivUt(); } else ventTesto(0);
      }).catch(function(e){ skrivUt(); feil(e.message); });
  }

  /* ---------- Email, esattamente dove la chiedono loro ---------- */
  var modal = document.getElementById('vq-modal');
  function apneEpost(){
    if (S.epost) return startSang();
    modal.hidden = false;
    setTimeout(function(){ document.getElementById('vq-epost').focus(); }, 80);
  }
  document.getElementById('vq-epost-ok').addEventListener('click', function(){
    var e = document.getElementById('vq-epost').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)) {
      document.getElementById('vq-epost').style.borderColor = '#C2552F';
      return;
    }
    S.epost = e; modal.hidden = true; startSang();
  });
  document.getElementById('vq-epost').addEventListener('keydown', function(e){
    if (e.key === 'Enter') document.getElementById('vq-epost-ok').click(); });

  /* ---------- Incisione ---------- */
  function startSang(){
    feil('');
    venter('Spiller inn sangen&hellip;', 'Melodi, arrangement og vokal. Dette tar noen minutter: du kan la siden stå åpen.');
    fetch(API + '/api/song/' + S.jobId + '/approve', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ testo: S.testo, epost: S.epost })
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if (!res.ok) throw new Error(res.j.error || 'Vi fikk ikke startet innspillingen.');
        ventSang(0);
      }).catch(function(e){ skrivUt(); feil(e.message); });
  }

  function ventSang(n){
    if (n > 150) return feil('Innspillingen tar lengre tid enn vanlig. Vi sender den på e-post så snart den er klar.');
    fetch(API + '/api/song/' + S.jobId, {cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (j.status === 'ready') { tom(); visSang(); return; }
        if (j.status === 'failed') return feil('Innspillingen stoppet. Skriv til hei@vaarsang.com, så ordner vi det.');
        setTimeout(function(){ ventSang(n + 1); }, 4000);
      }).catch(function(){ setTimeout(function(){ ventSang(n + 1); }, 5000); });
  }

  /* ---------- La canzone e il paywall ---------- */
  function visSang(){
    progresso(null);
    scene.innerHTML =
      '<div class="vq-step"><h2>Sangen til ' + esc(S.svar.navn) + ' er ferdig</h2>' +
      '<p class="hint">Hør de første 45 sekundene. Resten ligger klar.</p>' +
      '<div class="vq-play">' +
        '<p class="lab">De første 45 sekundene</p>' +
        '<h3>' + esc(S.svar.navn) + '</h3>' +
        '<button class="vq-btn" id="vq-pl">&#9654;</button>' +
        '<div class="vq-prog"><i id="vq-pr"></i></div>' +
        '<p class="vq-time" id="vq-tm">0:00 / 0:45</p>' +
      '</div>' +
      '<div class="vq-pay">' +
        '<p class="pris">' + esc(PRIS) + '</p>' +
        '<p style="margin-top:6px;font-size:.9rem;color:#8C7B69;">én gang, ingen abonnement</p>' +
        '<ul><li>Hele låten, 2–3 minutter, mp3 i studiokvalitet</li>' +
            '<li>Tekstarket slik du har skrevet det</li>' +
            '<li>En gaveside du kan sende videre</li>' +
            '<li>Tre gratis rettinger hvis noe skal endres</li></ul>' +
        '<button class="vq-next" id="vq-kjop">Lås opp hele sangen</button>' +
        '<p class="vq-fine">Trygg betaling via Shopify. Vi sender den til ' + esc(S.epost) + '.</p>' +
      '</div></div>';

    var lyd = new Audio(API + '/api/song/' + S.jobId + '/preview');
    lyd.preload = 'auto';
    var knapp = document.getElementById('vq-pl');
    var bar = document.getElementById('vq-pr'), tid = document.getElementById('vq-tm');
    function mmss(s){ return Math.floor(s/60) + ':' + String(Math.floor(Math.max(0,s)%60)).padStart(2,'0'); }
    lyd.addEventListener('timeupdate', function(){
      var p = Math.min(100, lyd.currentTime / 45 * 100);
      bar.style.width = p + '%';
      tid.textContent = mmss(Math.min(lyd.currentTime, 45)) + ' / 0:45';
    });
    lyd.addEventListener('ended', function(){ knapp.innerHTML = '&#9654;'; });
    knapp.addEventListener('click', function(){
      if (lyd.paused) { lyd.play(); knapp.innerHTML = '&#10073;&#10073;'; }
      else { lyd.pause(); knapp.innerHTML = '&#9654;'; }
    });

    document.getElementById('vq-kjop').addEventListener('click', function(){
      /* Il numero del job viaggia come proprieta della riga: e cosi che
         l'ordine Shopify sa quale canzone consegnare. */
      var u = '/cart/' + VARIANT + ':1' +
              '?attributes[Sang]=' + encodeURIComponent(S.jobId) +
              '&attributes[Til]=' + encodeURIComponent(S.svar.navn || '') +
              '&checkout[email]=' + encodeURIComponent(S.epost);
      window.location.href = u;
    });
  }

  vis();
})();
